var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccounts(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .prefix__cls-1,.prefix__cls-3{fill:none}.prefix__cls-2{fill:#fff}.prefix__cls-2,.prefix__cls-3{stroke:#3063d5;stroke-width:1.6px}.prefix__cls-4{stroke:none}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__residents",
    transform: "translate(-386 -382)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_2272",
    d: "M0 0H40V40H0z",
    className: "prefix__cls-1",
    "data-name": "Rectangle 2272",
    transform: "translate(386 382)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Ellipse_1194",
    className: "prefix__cls-2",
    "data-name": "Ellipse 1194",
    transform: "translate(390 386)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    className: "prefix__cls-4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.2,
    className: "prefix__cls-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Ellipse_1195",
    className: "prefix__cls-2",
    "data-name": "Ellipse 1195",
    transform: "translate(398 392)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    className: "prefix__cls-4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.2,
    className: "prefix__cls-1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Trac\\xE9_1524",
    d: "M402.6 414.317l-6.792-6.819",
    className: "prefix__cls-3",
    "data-name": "Trac\\xE9 1524",
    transform: "translate(14.971 -2.033)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Trac\\xE9_1525",
    d: "M402.6 407.5l-6.792 6.819",
    className: "prefix__cls-3",
    "data-name": "Trac\\xE9 1525",
    transform: "translate(-1.029 -2.033)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccounts);
export default __webpack_public_path__ + "static/media/accounts.8842136f4c1bc3206224bf7da80cfe9d.svg";
export { ForwardRef as ReactComponent };